import {msg, str} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {openDialog} from '../../slices/statusSlice';
import {uncancelSubscription} from '../../slices/planSlice';
import store from '../../store';

@customElement('arc-uncancel-subscription-button')
export class UnCancelSubscriptionButton extends connect(store)(LitElement) {

	static properties = {
		loading: {type: String},
	};

	constructor() {
		super();
		this.loading = '';
	}

	stateChanged(state) {
		this.loading = state.plan.loading;
	}

	async onUnCancelSubscription() {
		const dialogOptions = {
			title: msg('uncancel_sub_confirm_title'),
			message: msg(str`uncancel_sub_confirm_message`),
			labelConfirm: msg('uncancel_sub_confirm_ok'),
			labelCancel: msg('uncancel_sub_confirm_cancel'),
		};
		const handleConfirm = async () => {
			await store.dispatch(uncancelSubscription());
			window.removeEventListener('confirm', handleConfirm);
		};
		window.addEventListener('confirm', handleConfirm);
		store.dispatch(openDialog(dialogOptions));
	}

	render() {
		return html`
			<arc-button
				@click=${() => this.onUnCancelSubscription()}
				title="${msg('uncancel_sub_button_label')}"
				type="secondary"
				?disabled="${this.loading === 'uncancelSubscription'}"
			></arc-button>
		`;
	}
}
